<template>
    <div class="user-manage">
        <div class="nav-bread">
            <el-radio-group v-model="radioPage" @change="switchPage(radioPage)">
                <el-radio :label="1">用户列表</el-radio>
                <el-radio :label="2">用户添加</el-radio>
            </el-radio-group>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
    data () {
        return {
            radioPage: 1
        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    methods: {
        switchPage (page) {
            if(page == 1) {
                this.$router.push({
                    'name': 'userlist'
                })
            }
            else if(page == 2) {
                this.$router.push({
                    'name': 'adduser'
                });
            }
        }
    }
}
</script>

<style scoped>
.user-manage .nav-bread {
    height: 50px;
    background-color: #fafafa;
    font-family: PingFangSC-Regular,Microsoft YaHei;
    padding: 0 50px;
    padding-top: 25px;
}
</style>




// WEBPACK FOOTER //
// src/pages/userManage/UserManage.vue